var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "plan", class: { selected: _vm.selected } },
    [
      _c("div", { staticClass: "header" }, [_vm._v("Whatsapp")]),
      _vm._v(" "),
      _c("div", { staticClass: "plan-price-section" }, [
        _c("div", { staticClass: "plan-price-details" }, [
          _c(
            "span",
            {
              staticClass: "amount",
              class: { tl: _vm.site.basePrice.currency === "tl" },
            },
            [
              _vm._v(
                _vm._s(
                  _vm.$_.get(
                    _vm.site,
                    "whatsappBasePrice.value",
                    _vm.DEFAULT_PRICING.BASIC.tl.price
                  )
                )
              ),
            ]
          ),
          _vm._v(" "),
          _c("i", [
            _c("i", { staticClass: "slash" }, [_vm._v("/")]),
            _vm._v(" "),
            _c("i", { staticClass: "billed-month" }, [
              _vm._v(
                _vm._s(_vm.$t("billing.month")) + "\n                    "
              ),
              _c("i", { staticClass: "billed-yearly hide" }, [
                _c("br"),
                _vm._v(_vm._s(_vm.$t("billing.billedMonthToMonth"))),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "md-button",
        {
          staticClass: "md-raised md-primary w-100",
          staticStyle: {
            transform: "scale(0.7)",
            "font-size": "x-large",
            "border-radius": "10%",
          },
          attrs: { disabled: _vm.selected },
          on: { click: _vm.onSelected },
        },
        [
          _vm._v(
            _vm._s(_vm.$t(_vm.selected ? "wp.subscribed" : "wp.subscribe")) +
              "\n    "
          ),
        ]
      ),
      _vm._v(" "),
      _c("span", { staticClass: "text-succes" }, [_vm._v("-")]),
      _vm._v(" "),
      _c("a-divider", [_vm._v(_vm._s(_vm.$t("wp.planDetails")))]),
      _vm._v(" "),
      _c("div", { staticClass: "features" }, [
        _c(
          "div",
          { staticClass: "feature" },
          [
            _c("a-icon", { attrs: { type: "check" } }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("wp.sendReceiveMessage")))]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature" },
          [
            _c("a-icon", { attrs: { type: "check" } }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("wp.sendReceiveImage")))]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature" },
          [
            _c("a-icon", { attrs: { type: "check" } }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("wp.sendReceiveAudio")))]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature" },
          [
            _c("a-icon", { attrs: { type: "check" } }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("wp.sendReceiveGif")))]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature" },
          [
            _c("a-icon", { attrs: { type: "check" } }),
            _vm._v(" "),
            _c("span", [_vm._v("Location Send & Receive")]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature" },
          [
            _c("a-icon", { attrs: { type: "check" } }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("wp.startChat")))]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature" },
          [
            _c("a-icon", { attrs: { type: "check" } }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("wp.supsisFunctionality")))]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature" },
          [
            _c("a-icon", { attrs: { type: "check" } }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("wp.onePhoneMultiAgent")))]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature" },
          [
            _c("a-icon", { attrs: { type: "check" } }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("wp.basicIntegration")))]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature" },
          [
            _c("a-icon", { attrs: { type: "check" } }),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(_vm.$t("wp.broadcastMessagesToContactFile"))),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature" },
          [
            _c("a-icon", { attrs: { type: "check" } }),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(_vm.$t("wp.broadcastMessageTemplates"))),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature" },
          [
            _c("a-icon", { attrs: { type: "check" } }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("wp.messageFlow")))]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature" },
          [
            _c("a-icon", { attrs: { type: "check" } }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("wp.textMessageSupport")))]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature" },
          [
            _c("a-icon", { attrs: { type: "check" } }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("wp.imageMessageSupport")))]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature" },
          [
            _c("a-icon", { attrs: { type: "check" } }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$t("wp.spamPreventions")))]),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }